/**
 * Normalize an axios error's `response.data.detail` to a human-readable string.
 *
 * FastAPI's 422 (Pydantic ValidationError) returns `detail` as an ARRAY of
 * `{type, loc, msg, input, ctx, url}` objects. Passing that array to
 * `toast.error(...)` (or otherwise rendering it as a React child) throws
 * "Objects are not valid as a React child" and can blank the whole page.
 *
 * Use this everywhere a caught API error is surfaced to the user via toast.
 *
 * Examples:
 *   normalizeDetail("Not found", "fallback")         // → "Not found"
 *   normalizeDetail([{msg:"bad", loc:["x"]}], "fb")  // → "bad"
 *   normalizeDetail(undefined, "Something failed.")  // → "Something failed."
 */
export function normalizeDetail(detail, fallback = "Something went wrong.") {
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (typeof d === "string" ? d : d?.msg || JSON.stringify(d)))
      .join("; ");
  }
  if (typeof detail === "object") return detail?.msg || JSON.stringify(detail);
  return String(detail);
}
